import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { ApiPartnerService } from '@app/api/api-partner.service';


@Component({
  selector: 'app-updatepaytv',
  templateUrl: './updatepaytv.component.html',
  styleUrls: ['./updatepaytv.component.css']
})
export class UpdatepaytvComponent implements OnInit {

  sn : string = '';
  customerid : string = '';
  notes : string  = '';
  status : string = '';
  returnoutput = '';

  textSearch = new FormControl('');
  workorderList : any = {};
  ServiceList: any = [];
  ViewSTB: any = {};
  paging : any = {};
  Billingtype : any = [];
  Servicetype : any = [];

  daynotif : any = [];
  
  fs : string;
  msearch : string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  alert_act='';
  alert_actmsg='';

  isOne= false;
  alert_failed = false
  alert_success = false

  table_load = true

	constructor(
		public partnerService: ApiPartnerService,
		private route: ActivatedRoute,
		private fb: FormBuilder
	) { }

	ngOnInit() {
		//this.loadStart();

	}


	loadStart() {
	// this.route.queryParams
	//   //.filter(params => params.order)
	//   .subscribe(params => {
	//     console.log(params); // {order: "popular"}

	//     //this.order = params.order;
	//     //console.log(this.order); // popular

	//     if (params.search != '' && params.search != undefined ){
	//       console.log('search');
	//       console.log(params.search);
	//      this.msearch = params.search; 
	//      this.querySearch = true;
	    

	//      this.currentParams = params;
	//      this.queryParams = '?'+this.queryStr(params);
	//      this.loadService(this.queryParams);
	    
	//     }else{
	//       this.querySearch = false;
	//       this.currentParams = params;

	//       this.queryParams = '?'+this.queryStr(params);
	//       console.log(this.queryParams);
	//       console.log(this.queryStr(params));
	//       /* pagination */
	//       this.loadService(this.queryParams);
	//     }
	//   });

	}

	submit(){
		//alert('ok');
		if ( this.customerid == null || this.customerid == ''){
			alert('Customer Id harap diisi');
			return;
		}
		
		//console.log(this.sn,this.notes,this.status);
		let arrcustomerid = this.customerid.split(",");
		console.log(arrcustomerid);
		//return;
		return this.partnerService.PostUpdatePayTvcustomer({customerid:arrcustomerid}).subscribe((output: any) => {
			console.log(output);

			this.returnoutput = output.data;
			
		  
		})
	}

	queryStr(options: any){
	    let params = new URLSearchParams();
	    for(let key in options){
	        params.set(key, options[key]) 
	    }
	    return params.toString();
	  }

	

  



  

}
